import React from "react";
import { isEmpty, isUndefined } from "lodash";
import { createFilterOptions } from "@material-ui/lab";
import AutoComplete from "./auto-complete";

const CreatableAutoComplete = ({
  createLabel,
  onSelectCustomOption,
  onChange,
  hasSearched,
  ...other
}) => {
  const { form: { setFieldValue }, field: { name }, ignoreInputMatchingFilter, sorter, loading } = other;

  const filterOptions = (allOptions, params) => {
    const options = !isUndefined(sorter) ? sorter(allOptions, params.inputValue) : allOptions;

    const optionFilter = ignoreInputMatchingFilter ? createFilterOptions({ stringify: () => params.inputValue }) : createFilterOptions();
    const filtered = optionFilter(options, params);

    // Suggest the creation of a new value
    // only when there are no matches, the results are not loading and the user has entered a valid search
    if (params.inputValue !== "" && isEmpty(filtered) && !loading && hasSearched) {
      filtered.push({
        inputValue: params.inputValue,
        label: `${createLabel} "${params.inputValue}" To The List`,
      });
    }

    return filtered;
  };

  const getOptionLabel = option => {
    // Value selected with enter, right from the input
    if (typeof option === "string") {
      return option;
    }

    return option?.label ?? "";
  };

  const handleOnChange = newValue => {
    if (typeof newValue === "string") {
      setFieldValue(name, {
        label: newValue,
      });
    } else if (newValue && newValue.inputValue) {
      // Create a new value from the user input
      setFieldValue(name, {
        label: newValue.inputValue,
        value: newValue.inputValue,
      });

      if (onSelectCustomOption) {
        onSelectCustomOption(newValue);
      }
    } else {
      setFieldValue(name, newValue);
    }

    if (onChange) {
      onChange(newValue, setFieldValue);
    }
  };

  return (
    <AutoComplete
      filterOptions={filterOptions}
      getOptionLabel={getOptionLabel}
      handleOnChange={handleOnChange}
      {...other}
    />
  );
};

CreatableAutoComplete.defaultProps = {
  createLabel: "Add",
  selectOnFocus: true,
  clearOnBlur: true,
  freeSolo: true,
  hasSearched: true, // used for drug selector to determine if the user has searched before showing the add option, other uses should not require it as they set the loading state on input
};

export default CreatableAutoComplete;
